import React, { useState, useEffect } from 'react';

/**
 * NavigationHeader - Main navigation and side menu
 * Based on DataFlex's actual navigation structure
 */
function NavigationHeader() {
  const [sideMenuOpen, setSideMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleSideMenu = () => {
    setSideMenuOpen(!sideMenuOpen);
  };

  const handleNavClick = (e, href) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const offset = 90;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = target.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setSideMenuOpen(false);
  };

  return (
    <header>
      {/* Header Top */}
      <div className="top-header-area bg-transparent">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="header-top-text">
                {/* ADDRESS OF PROJECT - Intentionally empty for now */}
              </div>
            </div>
            <div className="col-md-6">
              <div className="header-top-text text-end">
                <a href="mailto:projects@dataflexep.com" className="">
                  <i className="fa fa-comment-o me-2"></i>projects@dataflexep.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className={`navbar navbar-top-default navbar-expand-lg navbar-gradient gradient-bg1 nav-box-round ${scrolled ? 'fixed-nav' : ''}`}>
        <div className="container">
          <a href="/" title="Logo" className="logo">
            <img src="/images/DataFlex_HeaderLogo_white.png" alt="DataFlex Energy Partners" className="logo-dark default" />
          </a>

          {/* Nav Links */}
          <div className="collapse navbar-collapse" id="wexim">
            <div className="navbar-nav ms-auto">
              <a className="nav-link" href="/">Home</a>
              <a className="nav-link scroll" href="javascript:void(0)" onClick={(e) => handleNavClick(e, '#about')}>About</a>
              <a className="nav-link scroll" href="javascript:void(0)" onClick={(e) => handleNavClick(e, '#team')}>Goal</a>
              {/* PRESERVED: Portfolio link for future use */}
              {/* <a className="nav-link scroll" href="javascript:void(0)" onClick={(e) => handleNavClick(e, '#portfolio')}>Work</a> */}
              <a className="nav-link scroll" href="javascript:void(0)" onClick={(e) => handleNavClick(e, '#app')}>Why</a>
              <a className="nav-link scroll" href="javascript:void(0)" onClick={(e) => handleNavClick(e, '#blog')}>Who</a>
              <a className="nav-link scroll" href="javascript:void(0)" onClick={(e) => handleNavClick(e, '#contact')}>Connect</a>
            </div>
          </div>

          {/* Side Menu Button */}
          <a 
            href="javascript:void(0)" 
            className="d-inline-block sidemenu_btn" 
            id="sidemenu_toggle"
            onClick={toggleSideMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </a>
        </div>
      </nav>

      {/* Side Nav */}
      <div className={`side-menu ${sideMenuOpen ? 'side-menu-active' : ''}`}>
        <div className="inner-wrapper">
          <span className="btn-close" id="btn_sideNavClose" onClick={toggleSideMenu}>
            <i></i><i></i>
          </span>
          <nav className="side-nav w-100">
            <ul className="navbar-nav">
              <li className="nav-item">
                <a className="nav-link" href="/">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link scroll" href="javascript:void(0)" onClick={(e) => handleNavClick(e, '#about')}>About</a>
              </li>
              <li className="nav-item">
                <a className="nav-link scroll" href="javascript:void(0)" onClick={(e) => handleNavClick(e, '#team')}>Goal</a>
              </li>
              {/* PRESERVED: Portfolio link for future use */}
              {/* <li className="nav-item">
                <a className="nav-link scroll" href="javascript:void(0)" onClick={(e) => handleNavClick(e, '#portfolio')}>Work</a>
              </li> */}
              <li className="nav-item">
                <a className="nav-link scroll" href="javascript:void(0)" onClick={(e) => handleNavClick(e, '#app')}>Why</a>
              </li>
              <li className="nav-item">
                <a className="nav-link scroll" href="javascript:void(0)" onClick={(e) => handleNavClick(e, '#blog')}>Who</a>
              </li>
              <li className="nav-item">
                <a className="nav-link scroll" href="javascript:void(0)" onClick={(e) => handleNavClick(e, '#contact')}>Connect</a>
              </li>
            </ul>
          </nav>

          <div className="side-footer text-white w-100">
            <ul className="social-icons-simple">
              <li>
                <a className="linkedin-text-hvr" href="https://www.linkedin.com/company/dataflex-energy-partners" target="_blank" rel="noopener noreferrer">
                  <i className="fa fa-linkedin"></i>
                </a>
              </li>
            </ul>
            <p className="text-white">&copy; 2025 DataFlex Energy Partners.</p>
          </div>
        </div>
      </div>
      <a id="close_side_menu" href="javascript:void(0);" onClick={() => setSideMenuOpen(false)}></a>
    </header>
  );
}

export default NavigationHeader;